export function normalizeApiUrl(
  rawUrl: string | null | undefined,
): string | null | undefined {
  if (!rawUrl) {
    return rawUrl;
  }

  return rawUrl.trim().replace(/\/+$/, "");
}

export function normalizeAssessmentsApiUrl(
  rawUrl: string | null | undefined,
): string | null | undefined {
  const normalized = normalizeApiUrl(rawUrl);
  if (!normalized) {
    return normalized;
  }

  if (normalized.endsWith("/assessment-api")) {
    return `${normalized.slice(0, -"/assessment-api".length)}/assessments`;
  }
  return normalized;
}

export function getApiUrls(): {
  appApiUrl: string | null | undefined;
  assessmentsApiUrl: string | null | undefined;
} {
  return {
    appApiUrl: normalizeApiUrl(process.env.REACT_APP_API_URL),
    assessmentsApiUrl: normalizeAssessmentsApiUrl(
      process.env.REACT_APP_ASSESSMENTS_API_URL,
    ),
  };
}
